
import Vue from 'vue'
import Vuex from 'vuex'
import systemStore from './system'
import userStore from './user'

import vuejsStorage from 'vuejs-storage'
/*
  Root Vuex 관리 (2018/06/15 정재윤)
    - Session 관리
    - App 관리
*/

const makeRootStore = () => {
  var store = {
    state: {
      app: {
        title: '',
        version: '',
        state: '',
        startTime: '',
        appId: ''
      },
      session: {
        authenticated: false,
        timeout: 0,
        loginTime: 0,
        userId: '',
        mbrNo: '',
        mbrFnm: '',
        role: '',
        permission: [],
        mbrSxdsCd: ''
      },
      information: {
        locale: {
          langCode: localStorage.getItem('language') || 'ko',
          dateformatCode: localStorage.getItem('dateFormat') || 'ko',
          timeZoneCode: localStorage.getItem('timeZone') || 'Asia/Seoul',
          dateformat: {
            yyyymmdd: 'YYYY.MM.DD',
            yyyymmdddy: 'YYYY.MM.DD (dd)',
            yyyymmddhh24miss: 'YYYY.MM.DD HH:mm:ss',
            yyyymmddamhhmiss: 'YYYY.MM.DD A hh:mm:ss',
            yyyymmddhh24: 'YYYY.MM.DD HH',
            yyyymmddamhh: 'YYYY.MM.DD A hh',
            yyyymmddhh24mi: 'YYYY.MM.DD HH:mm',
            yyyymmddamhhmi: 'YYYY.MM.DD A hh:mm',
            yyyymmmdd: 'YYYY.MM.DD',
            yyyymmmdddy: 'YYYY.MM.DD (dd)'
          }
        }
      },
      data: {
        dataList: []
      }
    },
    getters: {
      getState: state => {
        return state
      },
      getApp: state => {
        return state.app
      },
      getAppTitle: state => {
        return state.app.title
      },
      getAppVer: state => {
        return state.app.version
      },
      getAppId: state => {
        return state.app.appId
      },
      getSession: state => {
        return state.session
      },
      getSessionAuth: state => {
        return state.session.authenticated
      },
      getSessionLoginTime: state => {
        return state.session.loginTime
      },
      getSessionTimeout: state => {
        return state.session.timeout
      },
      getSessionUserId: state => {
        return state.session.userId
      },
      getSessionMbrNo: state => {
        return state.session.mbrNo
      },
      getSessionMbrFnm: state => {
        return state.session.mbrFnm
      },
      getSessionRole: state => {
        return state.session.role
      },
      getSessionPermission: state => {
        return state.session.permission
      },
      getDataLink: state => {
        return state.data.dataList
      },
      getInformation: state => {
        return state.information
      },
      getLocale: state => {
        return state.information.locale
      },
      getDateFormat: state => {
        return state.information.locale.dateformat
      }
    },
    mutations: {
      // 앱 정보 관리
      UPDATE_APP_INFO (state, appInfo) {
        if (appInfo.title !== undefined) {
          state.app.title = appInfo.title
        }
        if (appInfo.version !== undefined) {
          state.app.version = appInfo.version
        }
        if (appInfo.startTime !== undefined) {
          state.app.startTime = appInfo.startTime
        }
        if (appInfo.appId !== undefined) {
          state.app.appId = appInfo.appId
        }
      },
      // 로그인 세션 처리
      LOG_IN (state, session) {
        if (session.authenticated !== undefined) {
          state.session.authenticated = session.authenticated
        }
        if (session.timeout !== undefined) {
          state.session.timeout = session.timeout
        }
        if (session.loginTime !== undefined) {
          state.session.loginTime = session.loginTime
        }
        if (session.userId !== undefined) {
          state.session.userId = session.userId
        }
        if (session.mbrNo !== undefined) {
          state.session.mbrNo = session.mbrNo
        }
        if (session.mbrFnm !== undefined) {
          state.session.mbrFnm = session.mbrFnm
        }
        if (session.role !== undefined) {
          state.session.role = session.role
        }
        if (session.permission !== undefined) {
          state.session.permission = session.permission
        }
        if (session.mbrSxdsCd !== undefined) {
          state.session.mbrSxdsCd = session.mbrSxdsCd
        }
      },
      // 로그아웃 세션 처리
      LOG_OUT (state) {
        state.session.authenticated = false
        state.session.loginTime = 0
        state.session.timeout = 0
        state.session.userId = ''
        state.session.mbrNo = ''
        state.session.mbrFnm = ''
        state.session.role = ''
        state.session.permission = []
      },
      DATA_LINK (state, data) {
        if ( data.length > 0 ) {
          state.data.dataList = data
        }
      },
      UPDATE_INFORMATION (state, information) {
        state.information = information
      },
      UPDATE_INFORMATION_DATE_FORMAT (state, dateformat) {
        state.information.locale.dateformat = dateformat
      }
    },
    actions: {
      LOG_IN ({commit}, {session}) {
        return commit('LOG_IN', session)
      },
      LOG_OUT ({commit}) {
        return commit('LOG_OUT')
      },
      UPDATE_APP ({commit}, appState) {
        return commit('UPDATE_APP', appState)
      },
      UPDATE_APP_INFO ({commit}, appInfo) {
        return commit('UPDATE_APP_INFO', appInfo)
      },
      DATA_LINK ({commit}, appList) {
        return commit('DATA_LINK', appList)
      },
      INFORMATION ({commit}, {information}) {
        return commit('UPDATE_INFORMATION', information)
      },
      DATE_FORMAT ({commit}, {dateFormat}) {
        return commit('UPDATE_INFORMATION_DATE_FORMAT', dateFormat)
      }
    },
    plugins: [
      vuejsStorage({
        keys: ['app'],
        namespace: 'mmp-app-info',
        driver: vuejsStorage.drivers.sessionStorage
      }),
      vuejsStorage({
        keys: ['session'],
        namespace: 'mmp-session-info',
        driver: vuejsStorage.drivers.sessionStorage
      })
    ]
  }

  return store
}

// 인스턴스 생성
const createInstance = () => {
  let store = ''

  console.log('create SystemStore()')

  Vue.use(Vuex)

  store = new Vuex.Store(
    makeRootStore()
  )

  // 시스템 용 vuex 로딩
  systemStore.init()
  // user 용 vuex 로딩
  userStore.init()

  return store
}

var vuexWrapper = {}
vuexWrapper.createInstance = createInstance

export default vuexWrapper



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/root.js